import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import type { Filter } from '@/models/common';
import { DEFAULT_FILTERS } from '../constants';
import type { TabType } from '../types';
interface UseHomeFiltersReturn {
  filters: Filter[];
  setFilters: (filters: Filter[]) => void;
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
  activeSurveysCount: number;
  setActiveSurveysCount: (count: number) => void;
  closedSurveysCount: number;
  setClosedSurveysCount: (count: number) => void;
  savedSelectFilter: Filter | null;
}
export const useHomeFilters = () => {
  const $ = _c(16);
  const [activeTab, setActiveTab] = useState("active");
  const [activeSurveysCount, setActiveSurveysCount] = useState(0);
  const [closedSurveysCount, setClosedSurveysCount] = useState(0);
  const [savedSelectFilter, setSavedSelectFilter] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [DEFAULT_FILTERS.EXCLUDE_CLOSED];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [filters, setFilters] = useState(t0);
  let t1;
  if ($[1] !== savedSelectFilter) {
    t1 = tab => {
      if (tab === "closed") {
        setFilters([DEFAULT_FILTERS.INCLUDE_CLOSED]);
      } else {
        if (savedSelectFilter) {
          setFilters([savedSelectFilter]);
        } else {
          setFilters([DEFAULT_FILTERS.EXCLUDE_CLOSED]);
        }
      }
    };
    $[1] = savedSelectFilter;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const updateFiltersForTab = t1;
  let t2;
  if ($[3] !== activeTab) {
    t2 = newFilters => {
      const statusFilter = newFilters.find(_temp);
      if (!statusFilter?.value || Array.isArray(statusFilter.value) && statusFilter.value.length === 0) {
        if (activeTab === "closed") {
          setFilters([DEFAULT_FILTERS.INCLUDE_CLOSED]);
        } else {
          setFilters([DEFAULT_FILTERS.EXCLUDE_CLOSED]);
        }
        setSavedSelectFilter(null);
        return;
      }
      if (statusFilter.operator === "in") {
        const values = statusFilter.value as string[];
        if (Array.isArray(statusFilter.value) && !values.includes("closed")) {
          setSavedSelectFilter(null);
        } else {
          setSavedSelectFilter(statusFilter);
        }
        setFilters([statusFilter]);
        return;
      }
      setFilters(newFilters);
    };
    $[3] = activeTab;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleSetFilters = t2;
  let t3;
  let t4;
  if ($[5] !== activeTab || $[6] !== updateFiltersForTab) {
    t3 = () => {
      updateFiltersForTab(activeTab);
    };
    t4 = [activeTab, updateFiltersForTab];
    $[5] = activeTab;
    $[6] = updateFiltersForTab;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== activeSurveysCount || $[10] !== activeTab || $[11] !== closedSurveysCount || $[12] !== filters || $[13] !== handleSetFilters || $[14] !== savedSelectFilter) {
    t5 = {
      filters,
      setFilters: handleSetFilters,
      activeTab,
      setActiveTab,
      activeSurveysCount,
      setActiveSurveysCount,
      closedSurveysCount,
      setClosedSurveysCount,
      savedSelectFilter
    };
    $[9] = activeSurveysCount;
    $[10] = activeTab;
    $[11] = closedSurveysCount;
    $[12] = filters;
    $[13] = handleSetFilters;
    $[14] = savedSelectFilter;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
function _temp(filter) {
  return filter.field === "status.label";
}